import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FieldPositioningOutstandingPage } from './field-positioning-outstanding';
import { BodyModule, GridModule, SharedModule } from '@progress/kendo-angular-grid';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    FieldPositioningOutstandingPage,
  ],
  imports: [
    IonicPageModule.forChild(FieldPositioningOutstandingPage),
    GridModule,
    SharedModule,
    BodyModule,
    PtKendoModule,
  ],
})
export class FieldPositioningOutstandingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/validation/field-positioning-outstanding/field-positioning-outstanding.module.ts